import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  List,
  ListItem,
  ListItemContent,
  ColorPaletteProp,
  ListDivider,
  Sheet,
  Table,
  iconButtonClasses,
  Button,
  IconButton,
  Card,
  Input,
  ButtonGroup,
  Option,
  Dropdown,
  MenuButton,
  Menu,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  DialogContent,
  FormControl,
  FormLabel,
  Stack,
  Select,
  MenuItem,
  Divider,
  AspectRatio,
  ModalOverflow,
} from "@mui/joy";
import { toast } from "react-toastify";
import { LoadingView, MapContainer, PageTitle, StatusBadge } from "../../../components";
import { formatDate } from "../../../utils";

import SearchIcon from "@mui/icons-material/Search";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

import {
  fetchPartnerReset,
  fetchPartnerRequest,
  addPartnerReset,
  addPartnerRequest,
} from "../../../store/actions";

import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import {
  CalendarMonthOutlined,
  FilterAltOutlined,
  FolderOpenOutlined,
  LocationOn,
  LocationOnOutlined,
  PersonAddOutlined,
  RefreshOutlined,
  RemoveRedEyeOutlined,
  WarningRounded,
} from "@mui/icons-material";
import { STATUS } from "../../../constant";
import { NAVIGATE_TO_PARTNERVIEWPAGE } from "../../../route/types";
import locations from "../../../assets/locations.json";

const MobileViewTable = ({ data, props }) => {
  return (
    <Box sx={{ display: { xs: "block", md: "none" } }}>
      {data.map((listItem, index) => (
        <List
          key={index}
          size="sm"
          sx={{
            "--ListItem-paddingX": 0,
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "start",
            }}
          >
            <ListItemContent
              sx={{ display: "flex", gap: 2, alignItems: "start" }}
            >
              <div>
                <Typography fontWeight={600} gutterBottom>
                  {listItem.name}
                </Typography>

                <Typography level="body-xs" gutterBottom>
                  <b>Partner Type:</b>
                  {
                    {
                      1: "Admin (T-bridge Technologies)",
                      2: "Bank",
                      3: "Mobile Service Providers",
                    }[listItem.partner_type]
                  }
                </Typography>

                <Button
                  size="sm"
                  variant="outlined"
                  // sx={{width: 10, height: 10}}
                  onClick={() =>
                    window.open(
                      "https://maps.google.com?q=" +
                        listItem.address.latitude +
                        "," +
                        listItem.address.longitude,
                    )
                  }
                >
                  <LocationOnOutlined />
                  <Typography level="body-xs">
                    {listItem.address.region +
                      ", " +
                      listItem.address.district +
                      ", " +
                      listItem.address.street}
                  </Typography>
                </Button>

                <Dropdown>
                  <MenuButton variant="plain" size="sm">
                    More ...
                  </MenuButton>
                  <Menu placement="bottom-end" sx={{ p: 1 }}>
                    <Typography level="body-sm" gutterBottom>
                      <b>Created at:</b> {formatDate(listItem.created_at)}
                    </Typography>
                    <Typography level="body-sm" gutterBottom>
                      <b>Approved at: </b>
                      {formatDate(listItem.approved_at)}
                    </Typography>
                  </Menu>
                </Dropdown>
              </div>
            </ListItemContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "flex-end",
                rowGap: 1,
              }}
            >
              <StatusBadge
                color={
                  {
                    1: "success",
                    2: "warning",
                    3: "neutral",
                    4: "danger",
                  }[listItem.status] as ColorPaletteProp
                }
              >
                {
                  {
                    1: "Active",
                    2: "Inactive",
                    3: "Pending",
                    4: "Rejected",
                  }[listItem.status]
                }
              </StatusBadge>
              <ButtonGroup variant="soft" size="sm">
                <Button color="primary" onClick={() => props.view(listItem)}>
                  <RemoveRedEyeOutlined />
                </Button>
              </ButtonGroup>
            </Box>
          </ListItem>
          <ListDivider />
        </List>
      ))}
    </Box>
  );
};

const DesktopViewTable = ({ data, props }) => {
  return (
    <React.Fragment>
      <Sheet
        className="OrderTableContainer"
        variant="outlined"
        sx={{
          display: { xs: "none", md: "flex", lg: "flex" },
          // width: '100%',
          borderRadius: "sm",
          flexShrink: 1,
          overflow: "auto",
          minHeight: 0,
        }}
      >
        <Table
          aria-labelledby="tableTitle"
          stickyHeader
          hoverRow
          sx={{
            "--TableCell-headBackground":
              "var(--joy-palette-background-level1)",
            "--Table-headerUnderlineThickness": "1px",
            "--TableRow-hoverBackground":
              "var(--joy-palette-background-level1)",
            "--TableCell-paddingY": "4px",
            "--TableCell-paddingX": "8px",
            "& tr > *:last-child": {
              position: "sticky",
              right: 0,
              bgcolor: "var(--TableCell-headBackground)",
            },
          }}
        >
          <thead>
            <tr style={{ textAlign: "center" }}>
              <th style={{ width: 100, padding: "10px 6px" }}>Name</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Type</th>
              <th style={{ width: 120, padding: "10px 6px" }}>Address</th>
              <th style={{ width: 100, padding: "10px 6px" }}>Created at</th>
              <th style={{ width: 100, padding: "10px 6px" }}>FSP Code</th>
              <th style={{ width: 50, padding: "10px 6px" }}>Status</th>
              <th aria-label="last" style={{ width: 100, padding: "10px 6px" }}>
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>
                  <Typography level="body-sm">{row.name}</Typography>
                </td>
                <td>
                  <Typography level="body-sm">
                    {
                      {
                        1: "Admin (T-bridge Technologies)",
                        2: "Bank",
                        3: "Mobile Service Providers",
                      }[row.partner_type]
                    }
                  </Typography>
                </td>
                <td>
                  <Box sx={{ display: "flex", gap: 0.5 }}>
                    <Button
                      size="sm"
                      variant="soft"
                      onClick={() =>
                        window.open(
                          "https://maps.google.com?q=" +
                            row.address.latitude +
                            "," +
                            row.address.longitude,
                        )
                      }
                    >
                      <LocationOnOutlined />
                    </Button>
                    <Typography level="body-sm">
                      {row.address.region +
                        ", " +
                        row.address.district +
                        ", " +
                        row.address.street}
                    </Typography>
                  </Box>
                </td>
                <td>
                  <Typography level="body-sm">
                    {formatDate(row.created_at)}
                  </Typography>
                </td>
                <td>
                  <Typography level="body-sm">{row.fsp_code}</Typography>
                </td>
                <td>
                  <StatusBadge
                    color={
                      {
                        1: "success",
                        2: "warning",
                        3: "neutral",
                        4: "danger",
                      }[row.status] as ColorPaletteProp
                    }
                  >
                    {
                      {
                        1: "Active",
                        2: "Inactive",
                        3: "Pending",
                        4: "Rejected",
                      }[row.status]
                    }
                  </StatusBadge>
                </td>
                <td>
                  <ButtonGroup variant="soft" size="sm">
                    <Button
                      title="View"
                      color="primary"
                      onClick={() => props.view(row)}
                    >
                      <RemoveRedEyeOutlined />
                    </Button>
                  </ButtonGroup>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Sheet>
    </React.Fragment>
  );
};

const PartnersPage = ({
  loginResult,

  partnerListStatus,
  partnerListResult,
  partnerListErrorMessage,

  addPartnerStatus,
  addPartnerResult,
  addPartnerErrorMessage,

  viewPartnerStatus,
  viewPartnerResult,
  viewPartnerErrorMessage,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width:600px)");
  const [agentData, setPartnerData] = useState([]);

  const [formModal, setFormModal] = useState(false);

  const [name, setName] = useState("");
  const [partner_type, setPatnerType] = useState("");
  const [location, setLocation] = useState({
    latitude: 0,
    longitude: 0,
  });
  const [nearest, setNearest] = useState("");
  const [ward, setWard] = useState("");
  const [street, setStreet] = useState("");
  const [other, setOther] = useState("");
  const [post_code, setPostCode] = useState("");
  const [zip_code, setZipCode] = useState("");
  const [email, setEmail] = useState("");

  const [attachments, setAttachments] = useState([
    {
      attachment_name: "",
      attachment_value: "",
      file: null,
      url: "",
    },
  ]);

  useEffect(() => {
    if (partnerListStatus === STATUS.SUCCESS) {
      setPartnerData(partnerListResult);
      // dispatch(fetchpartnerReset())
    } else if (partnerListStatus === STATUS.ERROR) {
      setPartnerData([]);
      toast.error(partnerListErrorMessage);
      dispatch(fetchPartnerReset());
    }

    if (addPartnerStatus === STATUS.SUCCESS) {
      toast.success("Partner added successful");
      setFormModal(false);
      dispatch(fetchPartnerRequest(loginResult.token));
      dispatch(addPartnerReset());
    } else if (addPartnerStatus === STATUS.ERROR) {
      toast.error(addPartnerErrorMessage);
      dispatch(addPartnerReset());
    }
  });

  useEffect(() => {
    dispatch(fetchPartnerRequest(loginResult.token));
  }, []);

  /* --------------- location (region and district data) ----------- */

  const [regionList, setRegionList] = useState([]);
  const [region, setRegion] = useState("");
  const [districtList, setDistrictList] = useState([]);
  const [district, setDistrict] = useState("");

  useEffect(() => {
    let _regions = [];
    locations.map((val) => {
      _regions.push(val.name);
    });
    setRegionList(_regions);
  }, []);

  useEffect(() => {
    //first clear selected district
    setDistrict("");
    locations.find((location) => {
      //return location.name = region
      let _districtList = [];
      if (location.name == region) {
        location.districts.map((val) => {
          _districtList.push(val.name);
        });
        setDistrictList(_districtList);
        return;
      }
    });
  }, [region]);

  const handleRegion = (event, newValue) => {
    setRegion(newValue);
  };

  const handleDistrict = (event, newValue) => {
    setDistrict(newValue);
  };

  /* ----------- end of location set ------------------ */

  /* -------- FUNCTION TO SEARCH ------ */
  const [search, setSearch] = useState("");
  const [filterBy, setFilterBy] = useState("name");

  // filtre by  name
  const filteredData = agentData.filter((item) => {
    if (filterBy === "name") {
      return item.name.toLowerCase().includes(search.toLowerCase());
    }
    // else if (filterBy === 'type') {
    //     return item.partner_type.includes(search)
    // }
    else if (filterBy === "created date") {
      return item.created_at.includes(search);
    }
    // else if (filterBy === 'address') {
    //     return item.address.toLowerCase().includes(search.toLowerCase())
    // }
    else {
      return item.name.toLowerCase().includes(search.toLowerCase());
    }
  });

  /* ------ pagination functions ------- */
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 20;
  const pageLength = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(0, prevPage - 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, pageLength - 1));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginatedData = filteredData.slice(
    currentPage * ITEMS_PER_PAGE,
    (currentPage + 1) * ITEMS_PER_PAGE,
  );
  /* ---- end of pagination functions ------- */

  /* -------- actions ----------- */

  const goToViewPage = (details) => {
    // dispatch(viewPartnerRequest(loginResult.token, data))
    navigate(NAVIGATE_TO_PARTNERVIEWPAGE, {
      state: {
        partner_id: details.id,
      },
    });
  };

  const openAddForm = () => {
    setName("");
    setPatnerType("");
    setDistrict("");
    setRegion("");
    setWard("");
    setStreet("");
    setOther("");
    setPostCode("");
    setZipCode("");
    setNearest("");
    setLocation({
      latitude: 0,
      longitude: 0,
    });
    setAttachments([
      {
        attachment_name: "",
        attachment_value: "",
        file: null,
        url: "",
      },
    ]);

    setFormModal(true);
  };

  const submitForm = (event) => {
    event.preventDefault();
    if (name && street && ward && partner_type && region && district) {
      const formData = new FormData();

      formData.append("partner_name", name);
      formData.append("partner_type", partner_type);
      formData.append("email", email);
      formData.append("street", street);
      formData.append("ward", ward);
      formData.append("district", district);
      formData.append("region", region);
      formData.append("zip_code", zip_code);
      formData.append("post_code", post_code);
      formData.append("latitude", location.latitude.toString());
      formData.append("longitude", location.longitude.toString());
      formData.append("nearest_landmark", nearest);
      formData.append("other_details", other);

      attachments.forEach((item, index) => {
        if (item.file && item.file instanceof File) {
          formData.append(`attachments[${index}].file`, item.file);
          formData.append(
            `attachments[${index}].attachment_name`,
            item.attachment_name || "",
          );
          formData.append(
            `attachments[${index}].attachment_value`,
            item.attachment_value || "",
          );
        }
      });

      dispatch(addPartnerRequest(loginResult.token, formData));
    } else {
      toast.error("Please fill all required information");
    }
  };

  // FUNCTION TO GET LOCATION
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error getting location:", error.message);
          // alert(`geolocation Error: ${JSON.stringify(error)}`)
          // toast.error(`geolocation Error: ${error.message}`)
        },
      );
    } else {
      alert(
        "Geolocation is not supported with this browser, please use another browser for completion",
      );
    }
  };

  // FUNCTION TO ADD, REMOVE AND HANDLE COLLATERAL INPUTS
  const addAttachmentsData = () => {
    setAttachments([
      ...attachments,
      {
        attachment_name: "",
        attachment_value: "",
        file: null,
        url: "",
      },
    ]);
  };

  const removeAttachmentsData = (index) => {
    const updateData = [...attachments];
    updateData.splice(index, 1);
    setAttachments(updateData);
  };

  const handleAttachmentsChange = (index, field, text) => {
    const updatedFields = [...attachments];
    updatedFields[index][field] = text;
    setAttachments(updatedFields);
  };

  const handlePicture = (event, index) => {
    const updatedFields = [...attachments];
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      updatedFields[index]["file"] = file;
      updatedFields[index]["url"] = URL.createObjectURL(file);
      setAttachments(updatedFields);
    }
  };

  const handlePartnerAdd = (event, newValue) => {
    setPatnerType(newValue);
  };

  const checkLoading = () => {
    if (
      partnerListStatus === STATUS.LOADING ||
      addPartnerStatus === STATUS.LOADING ||
      viewPartnerStatus === STATUS.LOADING
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box>
      <PageTitle title={"Manage Partners"} />

      <LoadingView loading={checkLoading()} />

      {/* search */}
      <Sheet
        className="SearchAndFilters"
        sx={{
          display: "flex",
          my: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          // width: { xs: 'auto', md: '30%' },
          justifyContent: "space-between",
        }}
      >
        {/* only admin can add partner */}
        {loginResult.role === 1 && (
          <Button
            startDecorator={<PersonAddOutlined />}
            color="success"
            sx={{ width: "auto" }}
            onClick={openAddForm}
          >
            Add new Partner
          </Button>
        )}

        {agentData.length > 0 && (
          <Input
            size="sm"
            placeholder={`Search by ${filterBy}`}
            type={
              {
                date: "date",
                name: "text",
                address: "text",
                mobile: "number",
                type: "text",
              }[filterBy]
            }
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            startDecorator={
              filterBy === "date" ? <CalendarMonthOutlined /> : <SearchIcon />
            }
            endDecorator={
              <Dropdown>
                <MenuButton variant="plain">
                  {/* <Typography level="body-sm">Filter</Typography> */}
                  <FilterAltOutlined />
                </MenuButton>
                <Menu sx={{ minWidth: "120px", fontSize: "14px" }}>
                  <MenuItem
                    onClick={() => setFilterBy("name")}
                    selected={filterBy == "name"}
                  >
                    Name
                  </MenuItem>
                  {/* <MenuItem onClick={() => setFilterBy('type')} selected={filterBy == 'type'}>Type</MenuItem> */}
                  <MenuItem
                    onClick={() => setFilterBy("date")}
                    selected={filterBy == "date"}
                  >
                    Created at
                  </MenuItem>
                  {/* <MenuItem onClick={() => setFilterBy('address')} selected={filterBy == 'address'}>Address</MenuItem> */}
                </Menu>
              </Dropdown>
            }
            sx={{
              width: { xs: "auto", md: "30%" },
              textTransform: "capitalize",
            }}
          />
        )}
      </Sheet>

      {agentData.length > 0 ? (
        <>
          {/* ------ render different view depend on plafform -------- */}
          <MobileViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />
          <DesktopViewTable
            data={paginatedData}
            props={{
              view: goToViewPage,
              role: loginResult.role,
            }}
          />

          {/* Pagination */}
          {agentData.length > ITEMS_PER_PAGE && (
            <Box
              className="Pagination-laptopUp"
              sx={{
                pt: 2,
                gap: 1,
                [`& .${iconButtonClasses.root}`]: { borderRadius: "50%" },
                display: "flex",
              }}
            >
              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                startDecorator={<KeyboardArrowLeftIcon />}
                onClick={handlePreviousPage}
                disabled={currentPage === 0}
              >
                {isDesktop ? "Previous" : ""}
              </Button>

              <Box sx={{ flex: 1 }} />
              {/* for desktop to display page number */}
              {Array.from({ length: pageLength }).map((_, page) => (
                <IconButton
                  key={page}
                  size="sm"
                  variant={"outlined"}
                  color="neutral"
                  onClick={() => handlePageChange(page)}
                  disabled={currentPage === page}
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  {page + 1}
                </IconButton>
              ))}

              {/* for mobile to display page number */}
              <Typography
                level="body-sm"
                mx="auto"
                textAlign={"center"}
                sx={{ display: { xs: "flex", md: "none" } }}
              >
                Page {currentPage + 1} of {pageLength}
              </Typography>
              <Box sx={{ flex: 1 }} />

              <Button
                size="sm"
                variant="outlined"
                color="neutral"
                endDecorator={<KeyboardArrowRightIcon />}
                onClick={handleNextPage}
                disabled={currentPage === pageLength - 1}
              >
                {isDesktop ? "Next" : ""}
              </Button>
            </Box>
          )}
        </>
      ) : (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: "20%",
          }}
        >
          <WarningRounded
            sx={{ fontSize: "50px", color: "background.appcolor" }}
          />
          <Typography level="title-md">Resource not Found</Typography>
          <Typography level="body-sm" textAlign={"center"}>
            This can be either no Partner list available or network issue.
          </Typography>
          <Button
            onClick={() => dispatch(fetchPartnerRequest(loginResult.token))}
            startDecorator={<RefreshOutlined />}
          >
            REFRESH
          </Button>
        </Card>
      )}

      {/* ------ Modal form for add Partner details ------ */}
      <Modal open={formModal}>
        <ModalOverflow sx={{ pt: "70px" }}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            // aria-labelledby="modal-dialog-overflow"
            // layout="fullscreen"
            sx={(theme) => ({
              // pt: '600px',
              minWidth: { xs: "unset", md: "800px" },
              [theme.breakpoints.only("xs")]: {
                top: "60px",
                bottom: 0,
                left: 0,
                right: 0,
                // borderRadius: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflow: "auto",
              },
            })}
          >
            <ModalClose
              variant="outlined"
              onClick={() => setFormModal(false)}
            />
            <DialogTitle>{"Add Partner"}</DialogTitle>
            <DialogContent>Please enter Partner details correct.</DialogContent>
            <Stack
              component="form"
              onSubmit={submitForm}
              gap={2}
              sx={{ mt: 2 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* first name */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Partner Name</FormLabel>
                  <Input
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Enter partner name"
                  />
                </FormControl>

                {/* partner type */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Partner Type</FormLabel>
                  <Select
                    placeholder="Select partner type"
                    value={partner_type}
                    onChange={handlePartnerAdd}
                    required
                  >
                    <Option value="1">Admin (T-bridge Technologies)</Option>
                    <Option value="2">Bank</Option>
                    <Option value="3">Mobile Service Providers</Option>
                  </Select>
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* email */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Email</FormLabel>
                  <Input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Enter partner email"
                  />
                </FormControl>
              </Stack>

              <Typography level="title-md">Address</Typography>
              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* region */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Region</FormLabel>
                  <Select
                    placeholder="Select region"
                    value={region}
                    onChange={handleRegion}
                    required
                  >
                    {regionList.map((dt) => (
                      <Option value={dt}>{dt}</Option>
                    ))}
                  </Select>
                </FormControl>

                {/* district */}
                {region && (
                  <FormControl sx={{ flex: 1 }} required>
                    <FormLabel>District</FormLabel>
                    <Select
                      placeholder="Select district"
                      value={district}
                      onChange={handleDistrict}
                      required
                    >
                      {districtList.map((dt) => (
                        <Option value={dt}>{dt}</Option>
                      ))}
                    </Select>
                  </FormControl>
                )}
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* Ward */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Ward</FormLabel>
                  <Input
                    type="text"
                    value={ward}
                    onChange={(e) => setWard(e.target.value)}
                    placeholder="Enter ward"
                  />
                </FormControl>

                {/* street */}
                <FormControl sx={{ flex: 1 }} required>
                  <FormLabel>Street</FormLabel>
                  <Input
                    type="text"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    placeholder="Enter street"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* post code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Post code</FormLabel>
                  <Input
                    type="text"
                    value={post_code}
                    onChange={(e) => setPostCode(e.target.value)}
                    placeholder="Enter post code"
                  />
                </FormControl>

                {/* zip code */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Zip Code</FormLabel>
                  <Input
                    type="text"
                    value={zip_code}
                    onChange={(e) => setZipCode(e.target.value)}
                    placeholder="Enter zip code"
                  />
                </FormControl>

                {/* nearest land mark */}
                <FormControl required sx={{ flex: 1 }}>
                  <FormLabel>Nearest land mark</FormLabel>
                  <Input
                    type="text"
                    value={nearest}
                    onChange={(e) => setNearest(e.target.value)}
                    placeholder="Enter nearest landmark"
                  />
                </FormControl>
              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                {/* map */}
                {location.latitude != 0 && (
                  <Box>
                    <Typography level="title-sm">
                      * Point your location on map
                    </Typography>
                    <AspectRatio
                      variant="outlined"
                      ratio="1"
                      sx={{ width: 300, borderRadius: 4 }}
                    >
                      <MapContainer
                        latitude={location.latitude}
                        longitude={location.longitude}
                        setLocation={setLocation}
                      />
                    </AspectRatio>
                  </Box>
                )}
                {/* location coordinates */}
                <FormControl sx={{ flex: 1 }}>
                  <FormLabel>Location</FormLabel>
                  <Input
                    readOnly
                    placeholder={
                      location.latitude == 0
                        ? "<--- Click to open map"
                        : `lat: ${location.latitude} long: ${location.longitude}`
                    }
                    // value={location.latitude}
                    startDecorator={
                      <Button
                        variant="soft"
                        color="neutral"
                        startDecorator={<LocationOn />}
                        onClick={getLocation}
                      >
                        {location.latitude === 0
                          ? "Open map"
                          : "Current location"}
                      </Button>
                    }
                  />
                </FormControl>
              </Stack>

              {/* attachments */}
              <Typography level="title-md">Attachments</Typography>
              {attachments.map((field, index) => (
                <Box
                  key={index}
                  sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Attachment Name</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_name}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_name",
                            event.target.value,
                          )
                        }
                        placeholder="Enter attachment name"
                        required
                      />
                    </FormControl>
                    <FormControl sx={{ flex: 1 }} required>
                      <FormLabel>Value</FormLabel>
                      <Input
                        type="text"
                        value={field.attachment_value}
                        onChange={(event) =>
                          handleAttachmentsChange(
                            index,
                            "attachment_value",
                            event.target.value,
                          )
                        }
                        // slotProps={{input: {component: NumericFormatAdapter}}}
                        // startDecorator={"Tsh."}
                        required
                      />
                    </FormControl>
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <FormControl sx={{ flex: 1 }}>
                      <FormLabel>Attachment file</FormLabel>
                      <input
                        type="file"
                        id={`col-picture${index}`}
                        hidden
                        onChange={(event) => handlePicture(event, index)}
                      />

                      <Input
                        type="file"
                        startDecorator={
                          <Button
                            variant="soft"
                            color="neutral"
                            startDecorator={<FolderOpenOutlined />}
                          >
                            <label htmlFor={`col-picture${index}`}>
                              Choose File
                            </label>
                          </Button>
                        }
                        sx={{
                          // Define internal styles for the file input
                          '& input[type="file"]::file-selector-button': {
                            display: "none",
                          },
                        }}
                        onChange={(event) => handlePicture(event, index)}
                      />
                    </FormControl>

                    {field.url != "" && (
                      <AspectRatio
                        variant="outlined"
                        ratio="1"
                        sx={{ width: 150, borderRadius: 4 }}
                      >
                        <img src={field.url} loading="lazy" alt="" />
                      </AspectRatio>
                    )}
                  </Stack>

                  <Stack direction={{ xs: "column", md: "row" }} gap={2}>
                    <ButtonGroup sx={{ mt: 1 }}>
                      {field.file != null && (
                        <Button
                          onClick={addAttachmentsData}
                          variant="solid"
                          color="primary"
                        >
                          + Add
                        </Button>
                      )}
                      {attachments.length > 1 && (
                        <Button
                          onClick={() => removeAttachmentsData(index)}
                          variant="solid"
                          color="danger"
                        >
                          - Remove
                        </Button>
                      )}
                    </ButtonGroup>

                    <Divider sx={{ my: 2 }} />
                  </Stack>
                </Box>
              ))}

              {/* other info */}
              <FormControl sx={{ flex: 1 }}>
                <FormLabel>Other Details</FormLabel>
                <Input
                  type="text"
                  value={other}
                  onChange={(e) => setOther(e.target.value)}
                  placeholder="Enter other details if available"
                />
              </FormControl>

              <Stack gap={4} sx={{ mt: 2 }}>
                <Button type="submit" fullWidth>
                  Submit
                </Button>
              </Stack>
            </Stack>
          </ModalDialog>
        </ModalOverflow>
      </Modal>
    </Box>
  );
};

const mapStateToProps = ({ partner, auth }) => {
  const { otpResult: loginResult } = auth;
  const {
    partnerListResult,
    partnerListStatus,
    partnerListErrorMessage,

    addPartnerStatus,
    addPartnerResult,
    addPartnerErrorMessage,

    viewPartnerStatus,
    viewPartnerResult,
    viewPartnerErrorMessage,
  } = partner;

  return {
    loginResult,

    partnerListStatus,
    partnerListResult,
    partnerListErrorMessage,

    addPartnerStatus,
    addPartnerResult,
    addPartnerErrorMessage,

    viewPartnerStatus,
    viewPartnerResult,
    viewPartnerErrorMessage,
  };
};

export default connect(mapStateToProps, {})(PartnersPage);
